module.exports = __webpack_public_path__ + "img/gmb_en.194b97ef.gif";